import React, { useState } from "react";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import RequestProfessionChanges from "./PopupUpdate/PopupUpdate";
import { getVisaProfessionChnagesData } from "../../../../store/Api";

export default function ListVisaProfessionChanges({
  token,
  titles = [],
  list = [],
  updateData,
}) {
  const dispatch = useDispatch();
  const [Popup, setPopUp] = useState(false);
  const [serviceCharge, setServiceCharge] = useState();
  const [editingIndex, setEditingIndex] = React.useState();
  const [inputValue, setInputValue] = React.useState();
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [searchWords, setSearchWords] = useState([]);
  const [Apikey, setApiKey] = useState("");
  const [searchData, setSearchData] = useState([]);

  const apiCall = () => {
    updateData("123654");
  };

  const handleChangeRequest = (index) => {
    setEditingIndex(index);
    setPopUp(searchData[index]);
  };

  const update = async (type) => {
    try {
      const res = await nodeinstance.post(
        "/visaProfession/updatePayment/",
        type,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        updateData("");
        onClearResponse();
      } else {
        dispatch(
          setAppError({
            msg: res?.error,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  const styles = {
    container: {
      position: "relative",
      width: "200px",
    },
    input: {
      width: "100%",
      height: "35px",
      padding: "10px",
      paddingRight: "30px", // Space for the icon
      fontSize: "16px",
      border: "1px solid #ccc",
      borderRadius: "3px",
      outline: "none",
    },
    tickIcon: {
      position: "absolute",
      right: "10px",
      top: "50%",
      transform: "translateY(-50%)",
      fontSize: "18px",
      color: "green",
      cursor: "pointer",
    },
  };

  const onSearchChange = (e) => {
    setApiKey(e.target.value);
  };

  const onSearchClick = async () => {
    if (Apikey === "") {
      dispatch(
        setAppError({
          msg: "search filed should not be empty.",
        })
      );
      return;
    }
    // dispatch(getVisaProfessionChnagesData(token,Apikey));
    const response = await nodeinstance.get(
      `/visaProfession/search/${Apikey}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    if (response.status === 200) {
      setSearchData(response.data.data);
    }
    console.log("print.......");
  };

  const onClearResponse = () => {
    setSearchData([]);
    setApiKey("");
  };

  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2 mt-2"
          onClick={() => {
            onClearResponse();
          }}
        >
          <p>Clear filter</p>
        </button>
        <div style={styles.container} className="mt-2">
          <input
            type="text"
            placeholder="Search employee here"
            style={styles.input}
            value={Apikey}
            onChange={(e) => {
              onSearchChange(e);
            }}
          />
          <span
            style={styles.tickIcon}
            onClick={() => {
              onSearchClick();
            }}
          >
            ✔️
          </span>
        </div>
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>

      {/* <CountPerPage /> */}
      <div className="overflow-x-auto" style={{ backgroundColor: "white" }}>
        <table className="min-w-full divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {titles.map((columnName, index) => (
                <th
                  key={index}
                  scope="col"
                  className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                >
                  {columnName}
                </th>
              ))}
            </tr>
          </thead>
          {/* <div className="grid grid-cols-table-visa-profession-changes gap-5 p-6 bg-white text-center"> */}

          <tbody className="bg-white divide-gray-10">
            {searchData.length <= 0 ? (
              <tr>
                <td colSpan={13} className="text-center py-6">
                  <h1>Search employee to get the data</h1>
                </td>
              </tr>
            ) : (
              searchData?.map((list, index) => (
                <tr key={index}>
                  {/* <PaginationIndex index={index} /> */}
                  <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.employee_id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.name || "-"}
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.client_name || "-"}
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.visa_provider || "-"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.iqama_number || "-"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.passport_number || "-"}
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.visa_profession || "-"}
                  </td>

                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.visa_profession_level || "-"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.application_date || "-"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.new_visa_profession || "-"}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {list.new_visa_profession_level || "-"}
                  </td>
                  {/* <td className="px-6 py-4 whitespace-nowrap">
                    {list.new_visa_provider || "-"}
                  </td> */}

                  <button
                    className={`p-1 px-2 rounded-md text-white text-xs p-2 ${
                      list.status === "Payment Done"
                        ? `bg-success`
                        : list.status === "Profession Changed"
                          ? `bg-red` // Ensure it's not set to gray or other colors for changed statuses
                          : `bg-red`
                    }`}
                    onClick={() => {
                      setServiceCharge(list);
                      if (list.status === "Payment Done") {
                        update({
                          employee_id: list.employee_id,
                          status: 4,
                          new_visa_profession: list.new_visa_profession,
                        });
                      } else {
                        // Allow handling 'Request Changes' even for 'Profession Changed' status
                        handleChangeRequest(index);
                      }
                    }}
                  >
                    {list.status === "Payment Done"
                      ? "Update Status Profession change"
                      : "Request Changes"}
                  </button>

                  <hr
                    className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                  />
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Render UpdateForm component */}
      {Popup && editingIndex !== null && (
        <RequestProfessionChanges
          token={token}
          data={Popup}
          setPopUp={setPopUp}
          apiCall={apiCall}
          listData={serviceCharge}
        />
      )}
    </>
  );
}
